// extracted by mini-css-extract-plugin
export var container = "_no-0";